import { Button } from "react-bootstrap";
import { BsFillPatchExclamationFill } from "react-icons/bs";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

export default function NotFound() {
    const history = useHistory();

    const onBackBtnClick = () => history.push('/');

    return (
        <div className="text-center flex">
            <BsFillPatchExclamationFill
                fontSize={84}
                className="text-danger mt-5 mb-3"
            />

            <H2 className="text-danger">404</H2>

            <H3>
                पेज फेला परेन
            </H3>


            <Message>
                तपाईंले खोज्नु भएको पेज फेला परेन, URL सही छ भनी सुनिश्चित गर्नुहोस्। <br />
            </Message>

            <div>
                <Button onClick={onBackBtnClick}>होम  पेजमा फर्कनुहोस्</Button>
            </div>


        </div>
    )
}

const H2 = styled.h2`
    font-size: 6rem;
    font-weight: bold;
    margin-bottom: 0;
`

const H3 = styled.h3`
    font-size: 1.6rem;
    margin-top: 0;
    margin-bottom: 1rem;
    color: #dc4553;
`

const Message = styled.div`
    font-size: 1.2rem;
    margin-bottom: 1rem;
    color: #727272;
`;